<div class="rounded position-relative fruite-item">
    <a [routerLink]="['/detail/', product.sku]">
        <div class="fruite-img product-image-shadow">
            <img [src]="product?.imagen?.url" class="img-fluid w-100 rounded-top" alt="">
        </div>
    </a>
    <div class="text-white bg-secondary px-3 py-1 rounded position-relative category-band category-opacity">{{product?.categoria?.[0]?.nombre}}</div>
    <div class="p-3 border border-secondary border-top-0 rounded-bottom product-info" style="height: 20 rem !important">
        <div class="title-product">{{product?.nombre}}</div>
        <div class="p-2 description-container"> {{product?.descripcionCorta}} </div>
        <div class="d-flex flex-column justify-content-between flex-lg-wrap">
            <p class="text-dark fs-5 fw-bold mb-0"> {{product?.precioUnitario | currency}} <span class="small-label">+ IVA</span> </p>
            <a (click)="addCart()" class="btn border border-secondary rounded-pill px-1 text-primary"><i class="fa fa-shopping-bag me-2 text-primary"></i> Agregar al carrito</a>
        </div>
    </div>
</div>

